import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=7e496422&scoped=true&"
import script from "./Unauthorized.vue?vue&type=script&lang=ts&"
export * from "./Unauthorized.vue?vue&type=script&lang=ts&"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=7e496422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e496422",
  null
  
)

export default component.exports